import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store/store';

interface LabListState {
    list: any,
  }
  
const initialState:LabListState = {
    list:undefined,
}

export const LabListSlice = createSlice({
    name:"labList",
    initialState,
    reducers:{
        UpdateLabList: (state,action) => {
            state.list = action.payload.labList;
        },
        AddLab: (state,action) => {
            state.list = undefined;
        },
        EditLab: (state,action) => {
            state.list = undefined;
        },
        RemoveLab: (state,action) => {
            state.list = undefined;
        }
    }
})

export const {UpdateLabList,AddLab,EditLab,RemoveLab} = LabListSlice.actions

export const selectLabList = (state: RootState) => state.labList

export default LabListSlice.reducer;